import { getNewsletterEmailById } from "../../../Requests/newsletter-requests";

export const getEmail = async (emailId?: string) => {
	if (!emailId) {
		return null;
	}

	return await getNewsletterEmailById(emailId);
};
